module.exports = __webpack_public_path__ + "img/1772.c79b92be.gif";